var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"tw-h-full"},[_c('div',{staticClass:"tw-flex tw-h-full tw-items-center tw-justify-center"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"primary","indeterminate":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }